<div *ngIf="loading" class="flex align-items-center justify-content-center w-full pb-8 mb-8">
	<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>

<div *ngIf="!loading">
	<form [formGroup]="filterGroup">
		<div class="grid mt-0 px-3">
			<div [ngClass]="col4Responsive()" [class]="this.onExtendedMobile() ? 'pb-0' : ''">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'SELECT_INTERVAL_PERIOD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="intervalType" formControlName="type" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5" id="events-input-deviceFilter"
							placeholder="{{ 'SELECT_INTERVAL_PERIOD' | translate }}" (onChange)="changeDropdownValue()">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [ngClass]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">
						{{ getLabel() }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							[placeholder]="getLabel()" id="access-log-startTime-filter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" *ngIf="this.f.type.value==='day'" (onSelect)="changeCalendarValue()">
						</p-calendar>
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							[placeholder]="getLabel()" id="access-log-startTime-filter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" *ngIf="this.f.type.value==='week'" (onSelect)="changeCalendarValue()">
						</p-calendar>
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							[placeholder]="getLabel()" id="access-log-startTime-filter" view="month"
							dateFormat="mm/yy" [ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" *ngIf="this.f.type.value==='month'" (onSelect)="changeCalendarValue()">
						</p-calendar>
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							[placeholder]="getLabel()" id="access-log-startTime-filter" view="year"
							dateFormat="yy" [ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" *ngIf="this.f.type.value==='year'" (onSelect)="changeCalendarValue()">
						</p-calendar>
					</div>
				</div>
			</div>
			<!-- <div [ngClass]="col2Responsive()" [class]="this.onExtendedMobile() ? 'pb-0' : ''">
				<div class="flex">
					<button pButton pRipple icon="pi cm-reload" label="{{ 'REFRESH_AND_VIEW' | translate }}" (click)="refresh()"
						class="p-button-primary text-normal border-transparent font-medium py-1">
					</button>
				</div>
			</div> -->
			<div [ngClass]="col4Responsive()">
				<div class="flex">
					<button pButton pRipple icon="pi cm-download" label="{{ 'EXPORT_METRICS_LIST' | translate }}"
						(click)="exportLog()" class="p-button-primary text-normal border-transparent font-medium py-1">
					</button>
				</div>
			</div>
		</div>
	</form>

	<div class="grid mt-0">
		<div *ngIf="logData" class="col-12">
			<div class="flex align-items-center justify-content-center font-bold text-lg px-3">{{ getIntervalDate() }}
			</div>
		</div>

		<div [ngClass]="col6Responsive()">
			<p-chart type="line" [data]="chartHumidity" [options]="optionsHumidity" [responsive]="true"></p-chart>
		</div>
		<div [ngClass]="col6Responsive()">
			<p-chart type="line" [data]="chartTemp" [options]="optionsTemp" [responsive]="true"></p-chart>
		</div>
		<div [ngClass]="col6Responsive()" *ngIf="getTypeData() === 'day'">
			<p-chart type="line" [data]="chartOnOff" [options]="optionsOnOff" [responsive]="true"></p-chart>
		</div>
		<div [ngClass]="col6Responsive()" *ngIf="getTypeData() !== 'day'">
			<p-chart type="bar" [data]="chartOnOffBar" [options]="optionsOnOffBar" [responsive]="true"></p-chart>
		</div>
		<div [ngClass]="col6Responsive()" *ngIf="getTypeData() === 'day'">
			<p-chart type="line" [data]="chartOnline" [options]="optionsOnline" [responsive]="true"></p-chart>
		</div>
	</div>
</div>